import React, { Component } from "react";
import { css } from "@emotion/react";
import ClipLoader from "react-spinners/ClipLoader";

export default class AddToCartStatue extends Component {
    state = {
        isSuccessAddToCart: false,
    };

    componentDidUpdate(prevProps) {
        const { alreadyAddToCartList, listDataItem, isShowResult } = this.props;

        if (prevProps.isShowResult !== isShowResult) {
            this.setState({
                isSuccessAddToCart: false,
            });
        }

        if (prevProps.alreadyAddToCartList !== alreadyAddToCartList) {
            let exists = alreadyAddToCartList.filter(
                (item) => item.sku === listDataItem.sku
            );
            if (exists.length) {
                this.setState({
                    isSuccessAddToCart: true,
                });
            }
        }
    }

    render() {
        const override = css`
            display: block;
            margin: 0;
            position: absolute;
            top: 0;
            left: 0;
        `;
        const { isSuccessAddToCart } = this.state;
        return isSuccessAddToCart === false ? (
            <div className="clipLoaderWrap position-relative me-3">
                <ClipLoader loading={true} css={override} size={20} />
            </div>
        ) : (
            <small className="text-danger success">已加入購物車</small>
        );
    }
}
